export default "__VITE_ASSET__729686b3__"